import React from 'react';
import { SpinnerIcon, ReadyIcon, ErrorIcon, WarnIcon } from '../icons';

export default function DocStatusBadge({ status, qualityVerdict }) {
  if (status === 'pending') {
    return (
      <span className="doc-status-badge doc-status-pending" title="Indexing in progress…">
        <SpinnerIcon /> indexing
      </span>
    );
  }
  if (status === 'error') {
    return (
      <span className="doc-status-badge doc-status-error" title="Ingestion failed">
        <ErrorIcon /> error
      </span>
    );
  }

  // status === 'ready' — vary by quality verdict
  if (qualityVerdict === 'poor') {
    return (
      <span className="doc-status-badge doc-status-poor" title="Indexed but quality is poor — open report for details">
        <ErrorIcon /> poor quality
      </span>
    );
  }
  if (qualityVerdict === 'warn') {
    return (
      <span className="doc-status-badge doc-status-warn" title="Indexed with quality warnings — open report for details">
        <WarnIcon /> quality warning
      </span>
    );
  }
  return (
    <span className="doc-status-badge doc-status-ready" title="Ready to search">
      <ReadyIcon /> ready
    </span>
  );
}